import React, { PureComponent } from "react";
import UniqueUsersOverTimeBySubTopicChart from "./UniqueUsersOverTimeBySubTopicChart";
import { Icon, Dropdown } from "semantic-ui-react";
import { connect } from "react-redux";
import html2canvas from "html2canvas";
import { downloadCSVData, downloadCanvasWithTitle } from "../utils";
import DimmerComponent from "../../DimmerComponent";
import moment from "moment-timezone";
import { ReactComponent as DownloadIcon } from "../../../../../assets/svg/downloads.svg";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import NoData from "../NoData/NoData";
import IntervalSelector from "../IntervalSelector";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";

class UniqueUsersOverTimeBySubTopic extends PureComponent {
    constructor(props) {
        super(props);
        this.selectedTopic = null;
        this.state = {
            downloading: false,
            aggs_val: "default",
            hideLegend: false,
        };
        this.chartEl = React.createRef();
    }

    componentDidUpdate(prevProps) {
        let makeApiCall =
            (prevProps.graph_type === "line" && ["bar", "pie"].includes(this.props.graph_type)) ||
            (this.props.graph_type === "line" && ["bar", "pie"].includes(prevProps.graph_type));
        if (makeApiCall) this.props.changeGraphType(this.props.graph_type, makeApiCall);
    }

    downloadTopicsOverallCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let csvFmt = [];
        let comparisonCsvFmt;
        if (this.props.graph_type === "line") {
            let userTz = JSON.parse(localStorage.getItem("company")).user_timezone_name;
            csvFmt = [["Time"]];
            this.props.data.csvLineData[0].data.forEach((d) => {
                csvFmt.push([moment(d.x).tz(userTz).format("YYYY-MM-DD HH:mm")]);
            });
            this.props.data.csvLineData.forEach((t) => {
                csvFmt[0].push(`${t.name} (${t.topic_name})`);
                t.data.forEach((d, i) => {
                    csvFmt[i + 1].push(d.y);
                });
            });

            if (this.props.comparisionData && this.props.comparisionData.csvLineData[0].data) {
                comparisonCsvFmt = [[" Comparison Time"]];
                let topic = this.props.comparisionData.csvLineData[0].data;
                this.props.comparisionData.csvLineData[0].data.forEach((d) => {
                    comparisonCsvFmt.push([moment(d.x).tz(userTz).format("YYYY-MM-DD HH:mm")]);
                });
                let newComparisionData = [];
                let comparisionData = this.props.comparisionData.csvLineData;
                if (comparisionData?.length > 0) {
                    this.props.data.csvLineData.forEach((ele) => {
                        let subId = ele.subtopicId;
                        let data_index = comparisionData.filter((ele) => ele.subtopicId === subId);
                        newComparisionData.push(data_index[0]);
                    });
                    comparisionData = newComparisionData;
                }
                console.log(comparisionData);
                comparisionData.forEach((t) => {
                    comparisonCsvFmt[0].push(`${t.name} (${t.topic_name})`);
                    t.data.forEach((d, i) => {
                        comparisonCsvFmt[i + 1].push(d.y);
                    });
                });

                csvFmt.push(...comparisonCsvFmt);
                let firstIndLen = csvFmt[0].length;
                let lastIndLen = csvFmt[csvFmt.length - 1].length;

                let length;
                if (firstIndLen > lastIndLen) length = firstIndLen;
                else length = lastIndLen;

                let arr = [];
                for (let i = 0; i < length; i++) {
                    arr.push([]);
                    for (let j = 0; j < csvFmt.length; j++) {
                        if (csvFmt[j] && csvFmt[j][i]) arr[i].push(csvFmt[j][i]);
                        else arr[i].push(0);
                    }
                }
                csvFmt = arr;
            }
        } else {
            csvFmt.push(["Subtopic Name(Topic Name)", "Count"]);
            let csvData = this.props.data.csvData;
            csvData.forEach((ele, ind) => {
                csvFmt.push([`${ele.name} (${ele.topic_name})`, ele.y]);
            });
            csvFmt.push(["Total", this.props.data.total]);
        }
        downloadCSVData(csvFmt, this.props.widget.name);
    };

    renderDownloadButton(nodata) {
        return (
            <Dropdown
                disabled={nodata}
                trigger={
                    <div className="chart-header-icon">
                        <DownloadIcon className="chart-download-icon" />
                    </div>
                }
                icon={null}
                className="chart-download-dropdown hideable"
                direction="left">
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => this.downloadTopicsOverallCSV()}>CSV</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.downloadPNG(true)}>PNG</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.downloadPNG(false)}>PNG(Transparent)</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    downloadPNG = (options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        this.setState({ downloading: true });
        html2canvas(this.chartEl.current, { backgroundColor: options ? "#fff" : null }).then((canvas) => {
            this.setState({ downloading: false });
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    changeGraphType = (val) => {
        let makeApiCall =
            val === "line" || ["bar", "pie"].includes(this.props.graph_type) || (this.props.graph_type === "line" && ["bar", "pie"].includes(val));
        this.props.changeGraphType(val);
    };
    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="This chart provides unique users for the subtopics you have selected in the filters. This indicates how many unique people are talking about the subtopics."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!nodata && (
                            <div className="chart-type">
                                <span onClick={() => this.changeGraphType("pie")} className={this.props.graph_type === "pie" ? "active-chart" : ""}>
                                    <Icon name="pie chart" />
                                </span>
                                <span onClick={() => this.changeGraphType("bar")} className={this.props.graph_type === "bar" ? "active-chart" : ""}>
                                    <Icon name="bar chart" />
                                </span>
                                <span onClick={() => this.changeGraphType("line")} className={this.props.graph_type === "line" ? "active-chart" : ""}>
                                    <Icon name="line chart" />
                                </span>
                            </div>
                        )}
                        {!this.props.isResearchDashboard &&
                            this.props.graph_type !== "pie" &&
                            this.props.graph_type !== "bar" &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <Popup
                                    content="Chart Comparison Filters"
                                    position="bottom center"
                                    size="tiny"
                                    inverted
                                    className="skiptranslate"
                                    trigger={
                                        <div className={`chart-header-icon`} onClick={() => (!this.props.isPublic ? this.props.chartComparision() : null)}>
                                            <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                        </div>
                                    }
                                />
                            )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && <>{this.renderDownloadButton(nodata)}</>}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && this.props.graph_type !== "line" && (
                            <CustomCheckBox checked={this.props.showLabel} onClick={this.props.changeShowLabel} label="Show Labels" />
                        )}
                        {!nodata && <CustomCheckBox checked={this.props.hideCommonLegend} onClick={this.props.changehideCommonLegend} label="Show Legends" />}
                        {!nodata && (this.props.graph_type === "bar" || this.props.graph_type === "line") && (
                            <CustomCheckBox label="Show Grid Lines" checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} />
                        )}
                        {!nodata && this.props.graph_type === "line" && (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                                disableComparisonInterval={this.props.disableComparisonInterval}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate" ref={this.chartEl}>
                        <UniqueUsersOverTimeBySubTopicChart
                            currentChartType={this.props.graph_type}
                            data={this.props.data}
                            legendClick={this.props.legendClick}
                            addContextMenuListener={this.addContextMenuListener}
                            showLabel={this.props.showLabel}
                            showLegend={this.props.hideCommonLegend}
                            showGridLines={this.props.showGridLines}
                            resizedCount={this.props.resizedCount}
                            comparisionData={this.props.comparisionData}
                            widgetContainerRef={this.props.widgetContainerRef}
                            expandWidget={this.props.expandWidget}
                            downloading={this.state.downloading}
                            hideLegend={this.state.hideLegend}
                            chartComparisionFilterApplied={this.props.chartComparisionFilterApplied}
                        />
                        {this.state.downloading && <DimmerComponent />}
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        allTopics: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.topics : [],
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UniqueUsersOverTimeBySubTopic);
